import type { identifier } from '@core/models/base';
import { useSimpleRestService } from '@shared/composables/useSimpleRestService';
import type { ContactDisplayModel, ContactUpsertModel } from '@shared/models/customer/contact';
import { authedAxios, post } from '@shared/axios';
export const useStudioOrganizationContactService = (studioId: identifier, organizationId: identifier) => {
  const urlBase = `/api/studioadmin/studios/${studioId}/organizations/${organizationId}/contacts`;
  const { createOrUpdate, deleteItem: deleteStudioOrganizationContact } = useSimpleRestService<
    ContactDisplayModel,
    ContactUpsertModel,
    ContactUpsertModel
  >(urlBase);

  const addressHasValues = (address: ContactUpsertModel['address']) => {
    return Object.values(address ?? {}).some((el) => el != null && el !== '');
  };

  const upsertStudioOrganizationContact = async (id: identifier | undefined, contact: ContactUpsertModel) => {
    if (addressHasValues(contact.address)) {
      return await createOrUpdate(id, contact);
    }
  };

  const getStudioOrganizationContact = async () => await (await authedAxios.get<ContactDisplayModel>(urlBase)).data;

  const createEntryOrderContact = async (contact: ContactUpsertModel, jobId: identifier) => {
    return await post<ContactDisplayModel>(
      `/api/studioadmin/studios/${studioId}/organizations/${organizationId}/jobs/${jobId}/checkout/contact`,
      contact,
    );
  };

  return {
    upsertStudioOrganizationContact,
    getStudioOrganizationContact,
    deleteStudioOrganizationContact,
    createEntryOrderContact,
  };
};
